import { TApiaSelectPossibleValue, getLabel } from '@apia/util';
import { executionFloatingChatController } from '../../..';
import { ChatMessage, TMessageType } from '@apia/ai';

export const unableToSetValueError = (
  fieldName: string,
  actualValue: any,
  possibleValues: TApiaSelectPossibleValue[],
) => {
  executionFloatingChatController.addMessage(
    new ChatMessage(
      getLabel('msgAiFormsAssistantUnableToSetValue', {
        text: {
          TOK1: `${fieldName} (${actualValue})`,
          TOK2: possibleValues
            .filter((x) => x.value !== '')
            .map((x) => `[${x.label}]`)
            .join(' '),
        },
      }).text,
      'information' as TMessageType,
    ),
  );
};
